import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';

function showHeader(id: string, visibleTabIds: string[]): boolean {
  return visibleTabIds.includes(id);
}

interface PrismTabsContainerTabHeaderSignature {
  Args: {
    activeTabId: string;
    id: string;
    onSelectTab: (tabId: string) => unknown;
    visibleTabIds: string[];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLIElement;
}

const PrismTabsContainerTabHeader: TOC<PrismTabsContainerTabHeaderSignature> =
  <template>
    {{#if (showHeader @id @visibleTabIds)}}
      <li ...attributes>
        <button
          class="prism-tabs-container__header__tabs__list__action
            {{if
              (eq @activeTabId @id)
              'prism-tabs-container__header__tabs__list__action--active'
            }}
            "
          data-event-id="tab-switch"
          data-event-value={{@id}}
          type="button"
          {{on "click" (fn @onSelectTab @id)}}
        >
          {{yield}}
        </button>
      </li>
    {{/if}}
  </template>;

export default PrismTabsContainerTabHeader;
